import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router';
import Styles from './custom-challenge-styles.scss';
import { customChallengeState, Input, SubmitButton, FormStatus } from './components';
import { currentAccountState, Footer, loginFlowUserState, AuthHeader } from '@/presentation/components';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
const CustomChallenge = ({ validation, authentication }) => {
    const resetLoginState = useResetRecoilState(customChallengeState);
    const [state, setState] = useRecoilState(customChallengeState);
    const [loginFlowUser] = useRecoilState(loginFlowUserState);
    const { setCurrentAccount } = useRecoilValue(currentAccountState);
    const navigate = useNavigate();
    const validate = (field) => {
        const { verificationCode } = state;
        const formData = { verificationCode };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.verificationCodeError })));
    };
    useEffect(() => resetLoginState(), []);
    useEffect(() => validate('verificationCode'), [state.verificationCode]);
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            if (state.isLoading || state.isFormInvalid) {
                return;
            }
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            authentication
                .confirmCustomChallenge({
                verificationCode: state.verificationCode,
                user: loginFlowUser
            })
                .then(authResponse => {
                if (authResponse.challengeName === 'CUSTOM_CHALLENGE') {
                    setState(prev => (Object.assign(Object.assign({}, prev), { mainError: 'Incorrect verification code', isLoading: false })));
                }
                else {
                    setCurrentAccount(authResponse);
                    navigate('/');
                }
            })
                .catch(err => {
                setState(prev => (Object.assign(Object.assign({}, prev), { mainError: err.message, isLoading: false })));
                console.log(err);
            });
        }
        catch (error) {
            setState(Object.assign(Object.assign({}, state), { isLoading: false, mainError: error.message }));
        }
    };
    if (!loginFlowUser)
        return React.createElement(Navigate, { to: "/login", replace: true });
    return (React.createElement("div", { className: Styles.loginWrap },
        React.createElement(AuthHeader, null),
        React.createElement("form", { "data-testid": "form", className: Styles.form, onSubmit: handleSubmit },
            React.createElement("h2", null, "Multi factor Authentication"),
            React.createElement(Input, { type: "text", name: "verificationCode", placeholder: "Type your Verification Code" }),
            React.createElement(SubmitButton, { text: "Complete Login" }),
            React.createElement(Link, { "data-testid": "login-link", to: "/login", className: Styles.link }, "Go Back"),
            React.createElement(FormStatus, null)),
        React.createElement(Footer, null)));
};
export default CustomChallenge;
